import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

/** 조회 날짜와 표에 표시하는 시간을 모두 한국시간으로 맞춘다. */
export const formatLogDate = (value: string, includeSeconds = false): string =>
  dayjs(value)
    .utcOffset(9 * 60)
    .format(includeSeconds ? 'YYYY.MM.DD HH:mm:ss' : 'YYYY.MM.DD HH:mm');
